
import { ref } from 'vue';
import { translate } from "../libs/translation"
import { info } from "../libs/init"

export default {
    setup () {
        let deferredPrompt;
        const active = ref(false)
        const disabled = ref(false)
        const activeStatus = ref<string>(localStorage.getItem(`${info().id}-install-active`) ?? 'on')

        window.addEventListener("beforeinstallprompt", (e) => {
            console.log("beforeinstallprompt fired");
            // Prevent Chrome 76 and earlier from automatically showing a prompt
            e.preventDefault();
            // Stash the event so it can be triggered later.
            deferredPrompt = e;
            if (activeStatus.value === 'on') {
                // Show the install button
                active.value = true
            }
        })
        window.addEventListener("appinstalled", (evt) => {
            console.log("appinstalled fired", evt);
        })
        const install = () => {
            deferredPrompt.prompt();
            disabled.value = true
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === "accepted") {
                    console.log("PWA setup accepted");
                    active.value = false
                } else {
                    console.log("PWA setup rejected");
                }
                disabled.value = false
                deferredPrompt = null;
            });
        }

        const close = () => {
            active.value = false
            activeStatus.value = "off"
            localStorage.setItem(`${info().id}-install-active`, 'off')
        }
        return { translate, info: info(), active, disabled, install, close }
    }
}
